import React, { useState } from 'react';

import Messages from './Messages';


// function getStoreState (MessageStore) {
//     return {
//         // visible: MessageStore.getMessageCenterVisibility(),
//         alertMessages: MessageStore.getAlertMessages(),
//         infoMessages: MessageStore.getInfoMessages(),
//         warningMessages: MessageStore.getWarningMessages(),
//         errorMessages: MessageStore.getErrorMessages()
//     };
// }

const MessageCenter = props => {
    const [tab, setTab] = useState('Info')
    const toggleMessageCenter = (ev) => {
        ev && ev.preventDefault();
        // WorkspaceActions.toggleMessageCenter();
        props.toggleMessageCenter();
    }

    const openTab = (tab) => {
        // WorkspaceActions.openMesssageCenterTab(tab);
        // props.openMesssageCenterTab(tab);
        setTab(tab)
    }

    const handleMarkAction = (type, id) => {
        // console.log('mark', type, id);
        // WorkspaceActions.markMessageAsRead(type, id);
        props.actions.markMessageAsRead(type, id);
    }

    const getUnreadCount = (type) => {
        var messages = getMessages(type);
        var count = Object.keys(messages).reduce(function (total, id) {
            var msg = messages[id];
            return !msg.meta.read ? total + 1 : total;
        }, 0);

        if (count > 0) {
            return (<span className="pull-right">
                <span className="badge">{count}</span>
            </span>);
        }
    }

    const getMessages = (type) => {
        switch (type) {
            case 'Info': return props.infoMessages;
            case 'Warning': return props.warningMessages;
            case 'Alert': return props.alertMessages;
            case 'Error': return props.errorMessages;
        }
    }
    const renderMessageManager = () => {
        return (
            <div id="message-manager"
                className={props.isVisible ? 'active' : null}
            >
                <div className="wrapper">

                    <header className="row">
                        <div className="col-xs-11">
                            <h4>Messages</h4>
                        </div>
                        <div className="col-xs-1">
                            <span
                                className="close"
                                onClick={toggleMessageCenter}
                            >&times;
                            </span>
                        </div>
                    </header>

                    <hr/>

                    <div className="row">
                        <div className="col-md-2" style={{marginBottom: '1em'}}>
                            <ul className="nav nav-pills nav-stacked">
                                <li role="presentation" className={tab == 'Info' ? 'active' : ''}>
                                    <a href="javascript:void(0)" onClick={openTab.bind(null, 'Info')}>Info
                                        {getUnreadCount('Info')}
                                    </a>
                                </li>
                                <li role="presentation" className={tab == 'Warning' ? 'active' : ''}>
                                    <a href="javascript:void(0)" onClick={openTab.bind(null, 'Warning')}>Warnings
                                        {getUnreadCount('Warning')}
                                    </a>
                                </li>
                                <li role="presentation" className={tab == 'Alert' ? 'active' : ''}>
                                    <a href="javascript:void(0)" onClick={openTab.bind(null, 'Alert')}>Alerts
                                        {getUnreadCount('Alert')}
                                    </a>
                                </li>
                                <li role="presentation" className={tab == 'Error' ? 'active' : ''}>
                                    <a href="javascript:void(0)" onClick={openTab.bind(null, 'Error')}>Errors
                                        {getUnreadCount('Error')}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-10" style={{padding: '0 1em'}}>
                            <div id="message-listing-wrapper">
                                {renderActiveTab()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const renderActiveTab = () => {
        var messages = getMessages(tab);
        var actions = {
            handleMarkAction: handleMarkAction
        };

        return <Messages {...actions} type={tab.toLowerCase()}
            messages={messages}
        />;
    }

    if (props.isVisible) return renderMessageManager();
    return <span/>;
}

export default MessageCenter;
